import classNames from "classnames";

import { PercentChangeTag } from "../../../components/PercentChangeTag";
import { formatBalance, getBalanceColor } from "../../../utils/balance";
import { formatCurrency } from "../../../utils/currency";

import styles from "./BillingFeeCalculationSummaryItem.module.scss";

interface BillingFeeCalculationSummaryItemProps {
  label: string;
  value: number;
  secondaryValue?: number;
  percentChange?: number | null;
  reverseNegativeColors?: boolean;
  isBalance?: boolean;
}

export const BillingFeeCalculationSummaryItem: React.FC<BillingFeeCalculationSummaryItemProps> = ({
  label,
  value,
  secondaryValue,
  percentChange,
  isBalance = false,
  reverseNegativeColors = false,
}) => {
  const balanceColor = isBalance ? getBalanceColor(value, reverseNegativeColors) : undefined;
  const displayValue = isBalance ? formatBalance(value, formatCurrency) : formatCurrency(value);
  const shouldDisplayPercentChange = percentChange !== null && percentChange !== undefined;

  return (
    <div className={styles.container}>
      <p className={styles.label}>{label}</p>

      <h5 className={classNames(styles.value)} style={{ color: balanceColor }}>
        {displayValue}
        {shouldDisplayPercentChange && (
          <PercentChangeTag value={percentChange as number} reverseNegativeColors={reverseNegativeColors} />
        )}
      </h5>
      {secondaryValue !== undefined && <p className={styles.secondaryValue}>( {formatCurrency(secondaryValue)} )</p>}
    </div>
  );
};
